export const it = {
  save: 'Salva',
  update: 'Aggiorna',
  accept: 'Accetta',
  cancel: 'Annulla',
  close: 'Chiudi',
  add: 'Aggiungi',
  check: 'Controlla',
  certificate: 'Certificato',
  certificates: 'Certificati',
  certification: 'Certificazione',
  certifications: 'Certificazioni',
  'valid-certificate': 'Certificato valido',
  date: 'Data',
  'valid-thru': 'Valido fino a',
  dashboard: 'Home page',
  error: 'Pagina di errore',
  forms: 'Moduli',
  notifications: 'Notifiche',
  'my-profile': 'Il mio profilo',
  'my-documents': 'I miei documenti',
  'my-documents-academy': "Documenti del corso dell'Accademia",
  'no-documents-available': 'Nessun documento disponibile',
  'training-materials': 'Materiali di formazione',
  'open-in-webviewer': 'Apri nel viewer',
  expired: 'Scaduto',
  'expired-training-materials': 'Materiali di formazione scaduti',
  'academy-documents': "Documenti dell'Accademia",
  'completed-on': 'Completato il',
  'from-section': 'Dalla sezione',
  'from-task': 'Dal compito',
  'no-documents-in-course': 'Nessun documento disponibile in questo corso',
  'back-to-documents': 'Torna ai miei documenti',
  'unknown-course': 'Corso sconosciuto',
  'error-loading-documents': 'Errore durante il caricamento dei documenti',
  documents: 'Documenti',
  'register-headline': 'Registrazione',
  register: 'Registrarsi',
  search: 'Ricerca',
  print: 'Stampa',
  'printed-via': 'Stampato tramite www.evalcard.com',
  "settings": {
    "label": "Impostazioni",
    "publicProfile": {
      "showEmailInPublic": "Mostra email",
      "showPhoneInPublic": "Mostra telefono",
      "showAddressInPublic": "Mostra indirizzo"
    }
  },
  tables: 'Tabelle',
  tabs: 'Schede',
  myeval: 'EvalCard',
  'eval-id': 'Eval-ID',
  id: 'ID',
  timeline: 'Timeline',
  typography: 'Tipografia',
  admin: 'Amministratore',
  user: 'Utente',
  templateAuthor: 'Autore di modelli globali',
  users: 'Utente',
  'user-profile': 'Profilo utente',
  'company-name': 'Nome della società',
  'company-logo': "Logo dell'azienda",
  'company-profile': 'Profilo aziendale',
  'company-profile-admin': 'Profilo aziendale',
  'company-invitation': "Invito dell'azienda",
  'invitation-sent': 'Invito inviato',
  'new-password': 'Nuova password',
  'generate-new-password': 'Genera nuova password',
  'current-password': 'Password attuale',
  'repeat-password': 'Ripeti password',
  'password-successfully-changed': 'La password è stata modificata con successo',
  'password-reset': 'Ripristina password',
  'edit-user-profile': 'Modifica profilo utente',
  'edit-user-profile-admin': 'Modifica profilo utente',
  system: 'Sistema',
  widgets: 'Widget',
  wizard: 'Procedura guidata',
  logout: 'Esci',
  login: 'Accedi',
  companies: 'Aziende',
  'my-company': 'La mia azienda',
  'leave-company': "Esci dall'azienda",
  'delete-company': 'Elimina azienda',
  company: 'Azienda',
  uid: 'P.IVA/partita iva',
  employees: 'Dipendenti',
  employee: 'Dipendente',
  companyadmin: 'Admin',
  evalclient: 'Rappresentante autorizzato EVAL',
  coworker: 'Dipendente',
  'coworker-profile': 'Profilo del dipendente',
  'search-user': 'Cerca utente',
  'search-user-placeholder': 'Nome, email, nome utente, EVAL-ID',
  trainer: 'Formatore',
  'training-level': 'Livello di formazione',
  gtp: 'GTP',
  authorityAdmin: 'Admin',
  trainerRO: 'Formatore (solo lettura)',
  authorityAdminRO: 'Amministratore (solo lettura)',
  protocols: 'Rapporti di prova',
  report: 'Rapporto di prova',
  'new-report': 'Nuovo rapporto di prova',
  'all-reports': 'Tutti i rapporti di prova',
  'all-assets': 'Tutti gli oggetti',
  'report-from': 'Rapporto di prova daRapporto di prova daRapporto di prova da',
  'report-details': 'Dettagli rapporto di prova',
  data: 'Dati',
  info: 'Info',
  attachment: 'Allegato',
  contact: 'Contatto',
  continue: 'Continuare',
  start: 'Avviare',
  summary: 'Riepilogo',
  vin: 'VIN',
  'licence-plate': 'Numero di targa',
  owner: 'Proprietario',
  vehicles: 'Veicoli',
  vehicle: 'Veicolo',
  'vehicle-details': 'Dettagli del veicolo',
  companyVehicle: 'Veicolo aziendale',
  valid: 'Valido',
  invalid: 'Non valido',
  tester: 'Esaminatore',
  'vehicles-admin': 'Veicoli',
  'create-company-vehicle': 'Crea veicolo',
  'select-vehicle': 'Selezione veicolo',
  'my-vehicles': 'I miei veicoli',
  'my-vehicle': 'Il mio veicolo',
  asset: 'Oggetto',
  assets: 'Oggetti',
  'serial-number': 'Numero di serie',
  'asset-type': 'Tipo di oggetto',
  'asset-types': 'Tipi di oggetto',
  'calibration-valid-thru': 'Taratura valida fino al',
  'requires-calibration': 'Richiede taratura periodica',
  'calibration-warning-days': 'Preavviso (giorni)',
  'gtp-classes': 'Classi GTP',
  code: 'Codice',
  subtype: 'Sottotipo',
  icon: 'Icona',
  qualification: 'Qualifica (HTML)',
  gtpIcon: {
    car: 'Auto',
    forklift: 'Carrello elevatore',
    gauge: 'Contachilometri',
    'train-front': 'Treno',
    ship: 'Nave',
    plane: 'Aereo',
    settings: 'Ingranaggio',
    wrench: 'Chiave inglese',
  },
  photos: 'Foto',
  'new-vehicle': 'Nuovo veicolo',
  manufacturer: 'Costruttore',
  'no-manufacturer': '(Nessun costruttore)',
  'no-vehicle': '(Nessun veicolo)',
  'vehicle-manufacturer': 'Costruttore del veicolo',
  'create-vehicle': 'Crea veicolo',
  'create-vehicle-manufacturer': 'Creare il costruttore del veicolo',
  'construction-year': 'Anno di costruzione',
  'change-password': 'Modifica password',
  roles: 'Autorizzazioni',
  actions: 'Azioni',
  action: 'Azione',
  profile: 'Profilo',
  email: 'E-mail',
  basic: 'Base',
  "special": "Speciale",
  "breakdown": "Interruzione",
  "click-for-details": "Clicca per i dettagli",
  rights: 'Diritti',
  details: 'Dettagli',
  information: 'Informazioni',
  'details-and-information': 'Dettagli e informazioni',
  name: 'Nome',
  namename: 'Denominazione',
  firstname: 'Nome',
  lastname: 'Cognome',
  fullname: 'Nome completo',
  password: 'Password',
  street: 'Via',
  number: 'Numero',
  city: 'Città',
  country: 'Paese',
  'forgot-password': 'Hai dimenticato la password?',
  'recover-password': 'Reimposta password',
  back: 'Indietro',
  'back-to-login': 'Torna al login',
  'go-to-login': 'Vai al login',
  'choose-picture': 'Seleziona immagine',
  'choose-logo': 'Seleziona logo',
  'image-format-not-supported': 'Questo formato immagine non è supportato. Seleziona un file JPG o PNG.',
  'send-invitation': 'Invia invito',
  zipcode: 'CAP',
  previous: 'Indietro',
  abort: 'Annulla',
  'i-understand': 'Capito',
  no: 'No',
  yes: 'Sì',
  inputs: 'Ingressi',
  'user-activated': 'Attivato',
  'user-not-activated': "L'utente non è ancora attivato",
  'user-did-not-receive-activation-email': "L'utente non ha ancora ricevuto un'e-mail di attivazione",
  'allow-coworkers-to-show-on-profile': 'Mostra sul profilo utente dei dipendenti:',
  'resend-activation-email': 'Richiesta link di attivazione',
  'coworker-education-status': 'Stato di formazione dei dipendenti',
  card: 'Biglietto da visita',
  'certification-authority': 'Centro di certificazione',
  'certification-authority-admin': 'Centro di certificazione',
  'certification-authorities': 'Centri di certificazione',
  'delete-certification-authority': 'Cancella autorità di certificazione',
  'certificate-templates': 'Modelli di certificato',
  'certificate-template': 'Modello di certificato',
  'creating-certificates': 'I certificati vengono creati...',
  'issue-certificate': 'Rilascio del certificato',
  'issue-date': 'Data di emissione',
  'due-date': 'Data di scadenza',
  'issued-on': 'Rilasciato il',
  'issued-by': 'Rilasciato da',
  author: 'Emittente',
  'certificate-name': 'Nome del certificato',
  'certificate-number': 'Numero del certificato',
  'born-on': 'Nato il',
  mileage: 'Chilometraggio',
  public: 'Pubblico',
  'back-to-the-app': "Torna all'app",
  'can-create-reports': 'Può creare rapporti',
  'temporary-certification': 'Certificazione temporanea',
  'temporary-days-valid': 'Valido per (giorni)',
  'valid-for': 'Valido per (anni)',
  'pdf-template': 'Modello PDF',
  'pdf-certificate': 'Certificato PDF proprio',
  'show-pdf-certificate': 'Certificato in formato PDF',
  standards: 'Standard (HTML)',
  'text-block': 'Testo conforme agli standard (HTML)',
  'text-block-hint': 'Segnaposto: {placeholders} — qualifikationen inserisce i testi delle classi GTP assegnate',
  'digital-signature': 'Firma digitale',
  eval0: 'HV-0',
  eval1: 'HV-1',
  eval2: 'HV-2',
  eval3: 'HV-3',
  eval4: 'HV-4',
  evalc: 'HV-C',
  evalbex: 'HV-BEX',
  evall: 'HV-L',
  evalf: 'HV-F',
  evalpro: 'HV-Pro',
  evals: 'HV-S',
  evalt: 'HV-T',
  sonstige: 'Altro',
  others: 'Altro',
  levelGroupBase: 'Livelli Base',
  levelGroupSpecial: 'Speciale - richiede qualifiche precedenti',
  levelGroupSpecialTraining: 'Formazioni Speciali senza prerequisiti',
  level: 'Livello',
  type: 'Tipo',
  'training-data': 'Documenti di formazione',
  'training-info': 'Informazioni sulla formazione',
  'generated-password': 'Password generata',
  'invitation-email': 'Email di invito',
  document: 'Documento',
  active: 'attivo',
  inactive: 'inattivo',
  all: 'TUTTI',
  'all-sort': 'Tutti tipi',
  'created-on': 'Creato il',
  result: 'Risultato',
  results: 'Risultati',
  'try-again': 'Riprova',
  status: 'Stato',
  published: 'Pubblicato',
  draft: 'Bozza',
  sn: 'SN',
  'something-went-wrong': 'qualcosa non va',
  'checking-prerequisites': 'Controllo dei prerequisiti...',
  'prerequisite-warning-title': 'Prerequisiti mancanti',
  'missing-prerequisites': 'Richiede almeno:',
  'info-signs': 'Cartelli informativi',
  danger: 'Attenzione',
  'hazardous-voltage': 'Tensione elettrica pericolosa',
  'no-access-1': 'VIETATO L´ACCESSO',
  'no-access-2': 'ALLE PERSONE NON AUTORIZZATE',
  'access-only-by': 'Accesso solo tramite',
  'company-logo-is-missing': 'Manca il logo aziendale',
  download: 'Scaricare',
  'access-denied': 'Accesso vietato',
  'dont-switch-on': 'Non accendere',
  'hv-system': 'SISTEMA HV',
  disconnected: 'DISINSERITO',
  'disconnected-by': 'DISINSERITO da',
  'works-in-progress': 'Lavori in corso',
  forum: 'Forum EV',
  topic: 'Argomento',
  topics: 'Temi',
  title: 'Titolo',
  created: 'Creato',
  'created-by': 'Creato da',
  'is-global': 'Modello globale',
  'templateauthor-requires-report-permission': 'Solo gli utenti che possono creare report possono diventare autori di modelli globali.',
  from: 'da',
  answers: 'Risposte',
  'post-answer': 'Risposta al messaggio',
  'edit-answer': 'Modifica la risposta',
  'new-topic': 'Nuovo argomento',
  'edit-topic': 'Modifica argomento',
  'create-new-topic': 'Creare un nuovo argomento',
  'last-answer': 'Ultima risposta',
  'view-all': 'Visualizza tutti',
  attachments: 'Allegati',
  'link-url': 'Link (URL)',
  'newest-topics': 'Ultimi argomenti',
  'privacy-policy': 'Protezione dei dati',
  'new-files': 'Nuovi file',
  'existing-files': 'File esistenti',
  courses: 'Corsi',
  "location": "Posizione",
  participants: 'Partecipanti',
  loading: 'Caricamento',
  'view-details': 'Visualizza dettagli',
  'no-courses-found': 'Nessun corso trovato',
  'no-courses-assigned': 'Nessun corso disponibile',
  dialog: {
    'are-you-sure': 'Sei sicuro?',
    'an-unexpected-error-occured': 'Si è verificato un errore. Riprovare più tardi',
    'do-you-really-want-the-user-to': "Vuoi davvero l'utente",
    'do-you-really-want-the-invitation-to': "Vuoi davvero l'invito",
    delete: 'Elimina',
    'delete-user': 'Elimina utente',
    'delete-topic': "Cancellare l'argomento",
    'delete-topic-answer': 'Cancellare la risposta',
    'remove-user': 'Rimuovi utente',
    'remove-trainer': 'Rimuovere il recensore',
    'remove-from-company': "Rimuovere dall'azienda?",
    'remove-from-certification-authority': "Rimuovere dalla certificazione l'autorità?",
    'create-user': 'Crea utente',
    'the-most-important-information': 'Le informazioni più importanti',
    'create-company': 'Crea azienda',
    'the-most-important-information-about-the-company': 'Le informazioni aziendali più importanti',
    'create-company-vehicle': 'Creare veicolo aziendale',
    'the-most-important-information-about-the-vehicle': 'Le informazioni più importanti sul veicolo',
    'the-most-important-information-about-the-asset': "Le informazioni più importanti sull'oggetto",
    'create-report': 'Crea rapporto di prova',
    'where-is-the-company-located': "Dove si trova l'azienda?",
    'where-is-the-certification-authority-located': "dove si trova l'autorità di certificazione?",
    'whats-the-role-of-the-person': 'Qual è la funzione della persona?',
    'where-does-the-person-live': 'Dove vive la persona?',
    'further-details': 'Ulteriori dettagli',
    'register-successfull': "La registrazione è andata a buon fine! Riceverà a breve un'e-mail con la sua password",
    'great-you-will-receive-an-email': "Riceverà a breve un'e-mail per reimpostare la password",
    'this-should-not-take-longer-than':
      'Questa operazione non dovrebbe richiedere più di 5 minuti. In caso contrario, controllare anche la cartella spam',
    'i-agree': "Sono d'accordo con il",
    to: 'a',
    'terms-and-conditions': 'Termini e condizioni generali',
    'hereby-i-agree':
      "Accetto che EvalCert GmbH utilizzi i miei dati personali per l'emissione di una carta EVAL e per la registrazione dell'utente su my.evalcard.com",
    'further-i-agree-to':
      "Inoltre, acconsento che EvalCert GmbH possa informarmi tramite newsletter via e-mail sulle novità del settore dell'alta tensione (nuovi corsi di formazione, nuovi prodotti o eventi) fino a nuovo avviso",
    'allowed-to-be-used': '(.de o .com) può essere utilizzato',
    'refusal-is-allways': 'La cancellazione è possibile in qualsiasi momento via e-mail a',
    possible: 'possibile',
    'the-e-val-card-is-the':
      "La carta EVAL è il certificato di qualificazione in formato check card. L'abbreviazione EVAL sta per Electric Vehicle Access Licence",
    'complete-user-data': 'Completare da utente',
    'complete-user-data-info':
      'Per potervi fornire il miglior supporto possibile e per potervi mettere a disposizione tutte le funzioni, abbiamo bisogno di un profilo utente completo da parte vostra',
    'your-password-reset-is-being-processed':
      'La password viene reimpostata in questo momento. Se il processo dura più di qualche minuto, si prega di riprovare',
    'your-password-has-been-sent':
      "La password è stata reimpostata con successo. Dovrebbe ricevere un'e-mail con la nuova password entro pochi minuti",
    'if-it-did-not-work':
      'Si prega di controllare anche la cartella spam. Se non ha ricevuto la nuova password entro 5-10 minuti, la preghiamo di riprovare',
    'user-not-authorized': 'E-mail e/o password non corretti',
    'user-not-activated':
      "Questo utente non è ancora stato attivato. Utilizzare il link contenuto nell'e-mail di attivazione",
    'user-or-password-wrong': "L'e-mail o la password non sono corretti",
    'users-selected': 'Utente selezionato',
    'user-profile-update-successfull': 'Il profilo utente è stato salvato con successo',
    'user-profile-update-failed': 'Non è stato possibile salvare il profilo utente. Riprovare più tardi',
    'do-you-really-want-to-leave-the-company': "Sei sicuro di voler uscire dall'azienda?",
    'in-order-to-accept-a-company-invitation':
      "Per accettare l'invito di un'azienda, è necessario essere già registrati e aver effettuato l'accesso",
    'do-you-really-want-to-join-the-company': "Sei sicuro di volerti iscrivere all'azienda?",
    'if-you-are-already-in-a-company-you-will-be-removed': "Se siete già in un'azienda, verrete rimossi da essa",
    'you-are-not-a-member-of-a-company':
      "Al momento non sei assegnato a un'azienda. Non appena sarai membro di un'azienda, potrai utilizzare questa pagina",
    'you-are-not-a-member-of-a-certification-authority':
      'Al momento non siete assegnati all´autorità di certificazione',
    'do-you-really-want-the-company-to': "Volete davvero l'azienda",
    'company-created-successfully': "L'azienda è stata creata con successo",
    'company-already-exists':
      "Un'azienda con questo nome o email esiste già. Pertanto non è stato possibile creare l'azienda",
    'vehicle-save-successfully': 'Il veicolo è stato salvato con successo',
    'asset-save-successfully': "L'oggetto è stato salvato con successo",
    'gtp-class-save-successfully': 'La classe GTP è stata salvata con successo',
    'gtp-class-already-exists': 'Esiste già una classe GTP con questo codice',
    'do-you-really-want-the-gtp-class-to': 'Vuole davvero la classe GTP',
    'asset-type-save-successfully': 'Il tipo di oggetto è stato salvato con successo',
    'do-you-really-want-the-asset-type-to': 'Vuole davvero il tipo di oggetto',
    'vehicle-already-exists': 'Il veicolo con questo VIN e proprietario esiste già',
    'vehicle-accepted': 'Il veicolo è stato aggiunto al sistema',
    'vehicle-manufacturer-accepted': 'Il produttore del veicolo è stato aggiunto al sistema',
    'report-save-successfully': 'Il rapporto di ispezione è stato salvato con successo',
    'report-already-exists': 'Un rapporto di prova con questo nome e tipo esiste già in questa azienda',
    'create-company-failed': "Non è stato possibile creare un'azienda. Riprovare più tardi",
    'save-user-success': "L'utente è stato salvato con successo",
    'user-already-exists': 'Esiste già un utente con questo nome o e-mail',
    'save-company-success': "L'azienda è stata salvata con successo",
    'save-company-failed': 'Non è stato possibile salvare la società. Riprovare più tardi',
    'save-changes-success': 'Le modifiche sono state salvate con successo',
    'do-you-really-want-the-vehicle-to': 'Vuole davvero il veicolo',
    'do-you-really-want-the-asset-to': "Vuole davvero l'oggetto",
    'do-you-really-want-the-report-to': 'Vuole davvero il rapporto di prova',
    'do-you-really-want-the-certificate-to': 'Vuole davvero il certificato',
    'do-you-really-want-the-vehicle-manufacturer-to': 'Volete davvero il costruttore del veicolo',
    'save-vehicle-manufacturer-success': 'Il costruttore del veicolo è stato salvato con successo',
    'save-vehicle-manufacturer-error': 'Non è stato possibile salvare il costruttore del veicolo',
    'save-vehicle-success': 'Il veicolo è stato salvato con successo',
    'save-vehicle-error': 'Non è stato possibile salvare il veicolo',
    'who-works-in-the-company': 'Chi lavora in azienda?',
    'who-works-in-the-certification-authority': "Chi lavora presso l'autorità di certificazione?",
    'your-company-has-been-created-check-your-emails':
      "La vostra azienda è stata creata! Dovrebbe ricevere a breve un'e-mail con la quale potrà attivare la sua azienda! Se necessario, controllate la cartella spam",
    'if-you-havent-received-an-email-yet': "Se non ha ricevuto l'e-mail entro 5 minuti, può richiederla nuovamente qui",
    'if-this-did-not-work': 'Se non ha ancora funzionato, può anche lasciare la sua azienda e crearne una nuova',
    'is-already-in-a-company': "è già in un'azienda",
    'invite-user-already-exists-in-company': "L'utente con questa email è già in azienda",
    'invite-user-already-exists-in-other-company': "L'utente con questo indirizzo e-mail è già in un'altra azienda",
    'create-certification-authority': 'Crea autorità di certificazione',
    'certification-authority-save-successfully': "L'autorità di certificazione è stata salvata con successo",
    'certification-authority-already-exists':
      "Esiste già un'autorità di certificazione con questo indirizzo e-mail o nome",
    'certificate-already-exists': 'Per questo utente esiste già una certificazione con questo nome',
    'certificate-save-successfully': 'La certificazione è stata salvata con successo',
    'do-you-really-want-to-delete': 'Vuoi davvero eliminare',
    'delete-report-template': 'Elimina modello di lista di controllo',
    'create-certificate': 'Crea certificato',
    'create-certificate-template': 'Crea modello di certificato',
    'who-gets-the-certificate': 'A chi deve essere rilasciato il certificato',
    'user-with-this-eval-id-was-not-found': "L'utente con questo ID Eval non è stato trovato",
    'you-can-only-add-reports-if-you-have-company-vehicles':
      'È possibile creare un rapporto solo se si possiedono veicoli aziendali',
    'you-can-only-input-eu-numbers': 'Sono possibili solo numeri in formato UE',
    'you-dont-have-the-rights': "Nessuna autorizzazione per quest'area",
    'certificate-template-save-success': 'Il modello di certificato è stato salvato con successo',
    'certificate-template-sort-save-success': "L'ordinamento dei modelli di certificato è stato salvato con successo",
    'your-certification-authority-does-not-have-templates':
      'Si prega di creare prima un modello di certificato per poter emettere i certificati',
    'this-company-is-not-yet-activated':
      "Questa azienda non è ancora stata attivata. Il link di attivazione è stato inviato all'indirizzo e-mail dell'azienda",
    'welcome-to-the-dashboard':
      "Benvenuto nella home page! Non sei ancora assegnato a un'azienda. Non appena sarai membro di un'azienda, potrai vedere qui una panoramica dei tuoi protocolli",
    'valid-certificates': 'Certificati validi',
    'certificates-last-30-days': 'Certificati - ultimi 30 giorni',
    'certificates-on': 'Certificati del',
    'reports-last-30-days': 'Rapporti di prova - ultimi 30 giorni',
    'no-data-available': 'Nessun dato ancora disponibile',
    'this-manufacturer-does-not-exist':
      'Questo produttore non è ancora presente nel sistema. Verrà creato automaticamente',
    'this-vehicle-does-not-exist': 'Questo veicolo non è ancora presente nel sistema. Verrà creato automaticamente',
    'required-to-complete-registration': 'È necessario il consenso per completare la registrazione',
    'email-is-already-used': 'Questo indirizzo e-mail è già stato assegnato',
    'enter-valid-birthday-date': 'Si prega di inserire una data di nascita valida',
    'enter-valid-eu-number-format': 'Si prega di utilizzare solo numeri in formato UE',
    'only-use-numbers-with-or': "Si prega di utilizzare solo numeri e '-' o '/'",
    'this-user-is-already-in-this-certification-authority':
      'Questo utente è già presente in questa autorità di certificazione',
    'this-user-is-already-selected': 'Questo utente è già selezionato',
    'this-user-is-already-in-a-company': "Questo utente fa già parte di un'azienda",
    'the-document-could-not-be-loaded': 'Non è stato possibile caricare il documento',
    '': '',
    continue: 'Continuare',
    finish: 'Finitura',
    'course-created-successfully': 'Corso creato con successo',
    'course-updated-successfully': 'Corso aggiornato con successo',
    'mark-course-as-free': 'Segna il corso come gratuito',
    'participants-added-successfully': 'Partecipanti aggiunti con successo',
    'scan-qr-code': 'Scansiona il codice QR',
    'scan-to-join-course': 'Scansiona il codice QR per partecipare al corso',
    'remove-participant': 'Rimuovi partecipante',
    'remove-participant-description': 'Rimuovere questo partecipante dal corso?',
    'user-is-already-participant': 'Questo utente è già un partecipante al corso',
    'user-already-selected': 'Utente già selezionato',
    'cannot-add-users': 'I seguenti utenti hanno avuto conflitti:',
    "add-course": "Aggiungi corso",
    "delete-course": "Elimina corso",
    "delete-course-description": "Questo corso verrà eliminato. Tutti i partecipanti verranno rimossi. Continuare?",
    "course-removed": "Corso rimosso",
    "create-checklist": "Crea lista di controllo",
    "make-efk-success": "PES creato con successo, puoi scaricarlo ora",
    "resend-efk-success": "Invito PES reinviato con successo",
    "delete-document": "Elimina documento",
    "delete-document-description": "Vuoi davvero eliminare questo documento",
    "delete-certificate-template": "Elimina modello di certificato",
    "do-you-really-want-the-certificate-template-to": "Vuoi davvero eliminare il modello di certificato",
    'do-you-really-want-the-certification-authority-to': "Vuoi davvero eliminare l'autorità di certificazione",
    'delete-task': 'Elimina attività',
    'do-you-really-want-to-delete-the-task': 'Vuoi davvero eliminare l\'attività "{name}"?',
    'delete-section': 'Elimina Sezione',
    'do-you-really-want-to-delete-the-section': 'Vuoi davvero eliminare la Sezione "{name}"?',
    'course-content-saved-successfully': 'Contenuto del corso salvato con successo',
    'remove-certification-authority': 'Rimuovi Autorità di Certificazione',
    'do-you-really-want-to-remove-certification-authority':
      'Vuoi davvero rimuovere l\'autorità di certificazione "{name}"?',
    'remove-course-content': 'Rimuovi Contenuto del Corso',
    'do-you-really-want-to-remove-course-content': 'Vuoi davvero rimuovere il contenuto del corso "{name}"?',
    'successfully-removed-course-content': 'Contenuto del corso rimosso con successo',
    'language-already-exists-in-course': 'La lingua selezionata esiste già in questo corso',
    'do-you-really-want-to-remove-course': 'Vuoi davvero rimuovere il corso "{name}"?',
    'successfully-removed-course': 'Corso rimosso con successo',
    'publish-course-warning':
      "Sei sicuro di voler pubblicare '{name}'? Una volta pubblicato, il corso non può essere modificato fino a quando non viene annullata la pubblicazione.",
    'unpublish-course-confirmation':
      "Sei sicuro di voler annullare la pubblicazione di '{name}'? Questo permetterà nuovamente le modifiche.",
    'course-published-successfully': 'Corso pubblicato con successo',
    'course-unpublished-successfully': 'Pubblicazione del corso annullata con successo',
    'successfully-enrolled-course': 'Iscrizione al corso avvenuta con successo',
    'remove-enrollment': 'Rimuovi Iscrizione',
    'do-you-really-want-to-remove-enrollment': "Vuoi davvero rimuovere l'iscrizione",
    'successfully-removed-enrollment': 'Iscrizione rimossa con successo',
    "remove-efk-success": "PES-status rimosso dall'utente con successo",
  },
  tooltip: {
    'csv-export': 'Esportazione CSV',
    'add-user': 'Aggiungi utente',
    'invite-user': 'Invita utente',
    'delete-user': 'Elimina utente',
    'remove-user': 'Rimuovi utente',
    'edit-user': 'Modifica utente',
    'view-user': 'Visualizza utente',
    'send-invitation-again': 'Reinvio invito',
    'send-activation-again': 'Reinvio del link di attivazione',
    'admin-cant-leave-company': "In funzione di rappresentante eval, non è possibile uscire dall'azienda",
    'leave-company': "Uscire dall'azienda",
    'add-company': 'Aggiungi azienda',
    'edit-company': 'Modifica azienda',
    'delete-company': 'Elimina azienda',
    'add-selected-users-to-company': "Aggiungi utenti selezionati a un'azienda",
    'add-selected-users-to-course': 'Aggiungi utenti selezionati a un corso',
    'add-vehicle': 'Aggiungi veicolo',
    'show-vehicle': 'Dettagli veicolo',
    'edit-vehicle': 'Modifica veicolo',
    'view-vehicle': 'Visualizza veicolo',
    'accept-vehicle': 'Trasferire il veicolo al sistema',
    'accept-vehicle-manufacturer': 'Trasferire il costruttore del veicolo al sistema',
    'delete-vehicle': 'Elimina veicolo',
    'add-asset': 'Aggiungi oggetto',
    'add-gtp-class': 'Aggiungi classe GTP',
    'edit-gtp-class': 'Modifica classe GTP',
    'delete-gtp-class': 'Elimina classe GTP',
    'add-asset-type': 'Aggiungi tipo di oggetto',
    'edit-asset-type': 'Modifica tipo di oggetto',
    'delete-asset-type': 'Elimina tipo di oggetto',
    'show-asset': 'Dettagli oggetto',
    'edit-asset': 'Modifica oggetto',
    'delete-asset': 'Elimina oggetto',
    'add-vehicle-manufacturer': 'Aggiungere il costruttore del veicolo',
    'edit-vehicle-manufacturer': 'Modifica del costruttore del veicolo',
    'delete-vehicle-manufacturer': 'Cancellare il costruttore del veicolo',
    'vehicle-details-missing': 'Mancano i dati del veicolo',
    'remove-invitation': 'Cancella invito',
    'send-missing-activations': 'Invia le e-mail di attivazione mancanti',
    'show-password': 'Mostra password',
    'hide-password': 'Nascondi password',
    'create-report': 'Crea rapporto di prova',
    'select-for-report': 'Seleziona per il rapporto di prova',
    'add-question': 'Aggiungi campo',
    'remove-question': 'Rimuovi campo',
    'create-certificates': 'Crea certificati',
    'view-certificate': 'Visualizza certificato',
    'delete-certificate': 'Elimina certificato',
    'view-report': 'Visualizza rapporto di prova',
    'delete-report': 'Elimina rapporto di prova',
    'no-pdf-found': 'Non è stato trovato alcun documento PDF',
    'add-report': 'Aggiungi rapporto di prova',
    'add-certificate': 'Crea certificato',
    'no-certificate-to-create-report': 'Non avete un certificato adeguato',
    'add-certification-authority': 'Crea autoritá di certificazione',
    'edit-certification-authority': 'Modifica autorità di certificazione',
    'delete-certification-authority': 'Elimina autorità di certificazione',
    'add-certificate-template': 'Crea modello di certificazione',
    'edit-certificate-template': 'Modifica modello di certificazione',
    'delete-certificate-template': 'Elimina modello di certificazione',
    'add-report-template': 'Aggiungi modello di lista di controllo',
    'edit-report-template': 'Modifica modello di lista di controllo',
    'delete-report-template': 'Elimina modello di lista di controllo',
    'view-certificate-training-data': 'Visualizza documenti di formazione',
    'save-sorting': 'Salva ordinamento',
    'mark-user': 'Seleziona utente',
    'open-topic': 'Visualizza argomento',
    'edit-topic': 'Modifica argomento',
    'delete-topic': 'Cancella argomento',
    'edit-topic-answer': 'Modifica risposta',
    'delete-topic-answer': 'Cancella risposta',
    'select-all-users': 'Seleziona tutti gli utenti',
    'add-course': 'Aggiungi corso',
    'show-qr': 'Mostra codice QR',
    'edit-course': 'Modifica corso',
    'publish-course': 'Pubblica corso',
    'unpublish-course': 'Annulla pubblicazione corso',
    'remove-course': 'Rimuovi corso',
    'view-course': 'Visualizza corso',
    'remove-efk': 'Rimuovi PES',
    'see-more': 'Vedi altro',
  },
  phone: 'Numero di telefono',
  address: 'Indirizzo',
  birthday: 'Data di nascita',
  'profile-picture': 'Immagine del profilo',
  userprofile: {
    'edit-profile': 'Modifica profilo',
    'public-profile': 'Profilo pubblico',
    'following-information': 'Le seguenti informazioni vengono visualizzate nel profilo pubblico',
    'notification-settings': "Se l'azienda non invia notifiche, questa impostazione non ha alcun effetto.",
  },
  'training-director': 'Istruttore di formazione',
  'participated-the-training': 'ha partecipato alla formazione',
  'result-protocol': 'Registro dei risultati',
  measurements: 'Valori misurati',
  freischaltung: 'Disattivazione',
  isolationswiderstand: 'Resistenza di isolamento',
  potentialausgleich: 'Equalizzazione del potenziale',
  r: {
    'measuring-instrument-functionality': 'Funzionalità dello strumento di misurazione',
    'positive-test-done': 'Test positivo eseguito',
    'voltage-between-hv-plus-and-chassis': 'Tensione tra HV+ e telaio',
    'voltage-between-hv-plus-and-hv-minus': 'Tensione tra HV+ e HV-',
    'voltage-between-hv-minus-and-chassis': 'Tensione tra HV- e telaio',
    'the-tester-accepts-the-security-instructions':
      "L'ispettore conferma la conformità alle istruzioni di sicurezza del produttore",
    'measuring-instrument-tested-at-reference-source':
      'Controllo del funzionamento dello strumento di misurazione su una fonte di riferimento?',
    'measuring-instrument-tested': 'Funzionamento dello strumento testato?',
    'absence-of-voltage': 'Nessuna tensione presente',
    'absence-of-voltage-confirmed': 'Nessuna tensione rilevata',
    voltage: 'Tensione (V)',
    'used-voltage': 'Tensione utilizzata',
    'used-test-voltage': 'Tensione di prova applicata',
    'isolation-standard': 'Valore di riferimento della resistenza di isolamento',
    'resistance-per-volt': 'Resistenza per volt',
    'hv-system-voltage': 'Tensione di esercizio HV / Tensione di sistema HV',
    'isolation-resistance-between-hv-plus-and-chassis': 'Resistenza di isolamento tra HV+ e telaio',
    'isolation-resistance-between-hv-minus-and-chassis': "Resistenza d'isolamento tra HV- e telaio",
    'further-measurements-if-needed': 'Ulteriore misurazione se richiesta',
    'test-current': 'Corrente di prova (A)',
    'test-current-q': 'Corrente di prova ...',
    'measuring-point': 'Punto di misura',
    'measuring-point-chassis-vs': 'Punto di misura telaio contro ...',
    'converter-housing': "Alloggiamento dell'inverter",
    'further-voltage-measurements-if-needed': 'Ulteriore misurazione della tensione, se desiderata',
    'measurements-ok-if-smaller-than-1-v': 'Risultato della misura positivo se la tensione misurata è inferiore a 1V',
    'visual-inspection': 'Ispezione visiva',
    'cable-visual-inspection': 'Cavo controllato per danni visibili?',
    'connector-visual-inspection': 'Connettore controllato per danni visibili?',
    'isolation-test': 'Test di isolamento',
    'cable-isolation-test': 'Resistenza di isolamento del cavo verificata?',
    'function-test': 'Test funzionale',
    'cable-function-test': 'Processo di ricarica testato con successo?',
    'charging-cable-inspection-notes': 'Ulteriori verifiche se necessario',
  },
  'new-report-no-id': 'Nuovo rapporto di prova',
  'required-field': 'Questo campo è obbligatorio',
  'fill-out-all-required-fields': 'Compilare tutti i campi obbligatori!',
  'valid-email-only': 'Inserire un indirizzo e-mail valido.',
  'max-characters': 'Max {count} caratteri',
  'certificate-notification': 'Notifiche di certificati',
  'certificate-notification-company': 'In questo modo è possibile disattivare le notifiche per tutti i dipendenti.',
  'calibration-notification': 'Notifiche di calibrazione',
  'calibration-notification-company': 'Promemoria prima della scadenza della calibrazione di un oggetto.',
  'haynes-pro-vehicle-details': 'HaynesPro Dettagli del veicolo',
  'haynes-pro-no-details': 'Non ci sono ulteriori dettagli per il veicolo selezionato.',
  'haynes-pro-hv-disconnect': 'Sistema alta tensione: scollegamento',
  'vehicle-details-admin': 'Dettagli del veicolo',
  'haynes-pro-details': 'HaynesPro Dettagli',
  'haynes-pro-details-admin': 'HaynesPro Dettagli',
  'haynes-pro-details-not-found': 'Purtroppo non è stato trovato nulla per questo veicolo.',
  'haynes-pro-load-error': 'Non è stato possibile caricare le istruzioni.',
  retry: 'Riprova',
  'haynes-pro-details-more-than-one-story': 'È stato trovato più di un manuale:',
  'join-course': 'Partecipa al corso',
  'join-course-description':
    'Vuoi davvero partecipare al corso? Il formatore del corso potrà quindi gestirti come partecipante al corso.',
  'course-id-required': "L'ID del corso è obbligatorio per partecipare a un corso!",
  'course-not-found': 'Corso non trovato',
  'error-loading-course': 'Errore nel caricamento del corso',
  'successfully-joined-course': 'Partecipazione al corso avvenuta con successo',
  'error-joining-course': 'Errore durante la partecipazione, contatta il tuo formatore.',
  refresh: 'Aggiorna',
  'edit-course': 'Modifica corso',
  'make-efk': 'Rendi PES',
  'make-efk-description': 'Vuoi davvero rendere questo utente un PES? Deve confermarlo.',
  'resend-efk-invitation': 'Reinvia invito PES',
  'cancel-efk': 'Annulla ordine PES',
  efk: 'PES',
  'efk-position': 'Posizione PES',
  'do-you-want-to-accept-efk-position': 'Vuoi davvero accettare questa posizione PES?',
  'do-you-want-to-refuse-efk-position': 'Vuoi davvero rifiutare questa posizione PES?',
  refuse: 'Rifiuta',
  'in-order-to-handle-efk-position': 'Per gestire la posizione PES, è necessario accettarla prima.',
  'efk-position-accepted': 'Posizione PES accettata con successo',
  'efk-position-refused': 'Posizione PES rifiutata con successo',
  pending: 'In attesa',
  aborted: 'Annullato',
  checklists: 'Liste di controllo',
  'all-checklists': 'Tutte le liste di controllo',
  manage: 'Gestire',
  'global-templates': 'Modelli globali',
  'global-template-authors': 'Autori di modelli globali',
  'add-global-template-author': 'Aggiungi autore globale',
  'remove-global-template-author-confirm': 'Rimuovere davvero come autore di modelli globali?',
  'report-templates': 'Modelli di liste di controllo',
  'report-template': 'Modello di lista di controllo',
  'create-report-template': 'Crea modello di lista di controllo',
  'edit-report-template': 'Modifica modello di lista di controllo',
  'delete-report-template': 'Elimina modello di lista di controllo',
  checklist: 'Lista di controllo',
  form: 'Modulo',
  'basic-information': 'Informazioni di base',
  'object-data': 'Dati oggetto',
  'object-data-configuration': 'Configurazione dati oggetto',
  'object-data-config-description':
    'Configura campi personalizzati per raccogliere dati quando il veicolo non è richiesto',
  'requires-vehicle': 'Richiede veicolo',
  'assigned-vehicles': 'Veicoli assegnati',
  'assigned-vehicles-hint': 'Vuoto = vale per tutti i veicoli',
  'assigned-vehicles-no-data': 'Cerca un veicolo …',
  'available-reports': 'Rapporti disponibili',
  'create-report-now': 'Crea rapporto',
  'vehicle-added-to-fleet': 'Il veicolo è ora tra i veicoli aziendali',
  'requires-asset': 'Richiede oggetto',
  'select-asset': 'Seleziona oggetto',
  'field-name': 'Nome campo',
  'display-name': 'Nome visualizzato',
  'add-field': 'Aggiungi campo',
  'questions-description': 'Configura le domande per questo modello',
  'add-question': 'Aggiungi domanda',
  'example-images': 'Immagini di esempio',
  'upload-example-images': 'Carica immagini di esempio',
  'remove-image': 'Rimuovi immagine',
  'images-uploaded-successfully': 'Immagini caricate con successo',
  'error-uploading-images': 'Errore nel caricamento delle immagini',
  'enable-validation': 'Abilita validazione',
  'validation-configuration': 'Configurazione validazione',
  'expected-value': 'Valore atteso',
  'at-least-one-language-required': 'È richiesta almeno una lingua',
  'language-not-available': 'Questa lingua non esiste',
  'multilingual-fields-info':
    'Campi multilingue: Inserisci solo le lingue per cui hai traduzioni. È richiesta almeno una lingua per nomi e domande.',
  operator: 'Operatore',
  'validation-value': 'Valore di validazione',
  equal: 'Uguale',
  'less-than': 'Minore di',
  'greater-than': 'Maggiore di',
  'form-vehicle-info':
    'Questo è un modello di Modulo. I moduli vengono utilizzati quando è richiesto un veicolo per il rapporto.',
  'checklist-object-data-info':
    'Questo è un modello di Lista di controllo. Le liste di controllo utilizzano la configurazione dei dati oggetto invece dei veicoli.',
  'protocols-title': 'Rapporti di prova',
  'evalus-reports': 'Rapporti di prova Evalus',
  'company-reports': 'Rapporti di prova aziendali',
  'custom-templates': 'Modelli personalizzati',
  description: 'Descrizione',
  questions: 'Domande',
  question: 'Domanda',
  unit: 'Unità',
  boolean: 'Booleano',
  // Chiave dedicata: il `number` generico è "Nummer" in DE (numero d'ordine), senso sbagliato qui.
  'question-type-number': 'Numero',
  dropdown: 'Elenco a discesa',
  options: 'Opzioni',
  option: 'Opzione',
  'add-option': 'Aggiungi opzione',
  'expected-option': 'Opzione attesa',
  'dropdown-options-required': 'Ogni domanda a elenco richiede almeno un\'opzione compilata',
  'no-questions-yet': 'Ancora nessuna domanda — aggiungi la prima',
  'no-fields-yet': 'Ancora nessun campo — aggiungi il primo',
  'question-incomplete': 'Questa domanda è ancora incompleta',
  text: 'Testo',
  'is-active': 'È attivo',
  'add-checklist': 'Aggiungi checklist',
  "select-checklist-template": "Seleziona modello di checklist",
  "no-checklist-templates-available": "Non ci sono modelli di checklist disponibili.",
  "template": "Modello",
  "checklist-object-data": "Dati oggetto checklist",
  "report-template-saved": "Modello di rapporto salvato con successo",
  "new-checklist": "Nuova checklist",
  "view-checklist": "Visualizza checklist",
  "checklist-from": "Checklist da",
  "checklist-details": "Dettagli checklist",
  "field": "Campo",
  "checklist-created-successfully": "Checklist creata con successo",
  "error-creating-checklist": "Errore durante la creazione della checklist",
  "tested-with-object": "Con l'oggetto",
  "required-asset-type": "Tipo di oggetto richiesto",
  "required-asset-type-hint": "Tipo di oggetto con cui deve essere eseguito questo controllo del veicolo. Lasciare vuoto se non serve nessun oggetto.",
  "can-calibrate": "Può tarare oggetti",
  "calibratable-asset-type": "Tipo di oggetto tarabile",
  "calibratable-asset-type-hint": "Con questa checklist si possono tarare solo oggetti di questo tipo.",
  "calibration-validity-months": "Validità taratura (mesi)",
  "calibration-validity-months-hint": "Se questa checklist viene completata senza errori, l'oggetto risulta nuovamente tarato per questo numero di mesi.",
  "select-required-asset": "Oggetto utilizzato",
  "asset-locked-calibration-expired": "Bloccato – taratura scaduta da oltre {days} giorni ({date})",
  "asset-calibration-expired-on": "Taratura scaduta il {date}",
  "asset-restricted-hint": "Questo controllo può essere eseguito solo con un oggetto di tipo «{type}».",
  "asset-none-of-required-type": "La sua azienda non ha nessun oggetto di tipo «{type}». Crei prima un oggetto adatto per poter eseguire questo controllo.",
  "asset-all-expired": "Tutti gli oggetti compatibili hanno una taratura scaduta da oltre {days} giorni e sono quindi bloccati. Aggiorni la data di taratura sull'oggetto per continuare.",
  "asset-no-longer-allowed": "L'oggetto selezionato non è (più) ammesso per questo controllo – la taratura potrebbe essere scaduta da troppo tempo. Verifichi la selezione.",
  "add-users-to-course": "Aggiungi utenti al corso",
  "selected-users": "Utenti selezionati",
  "start-date": "Data di inizio",
  "end-date": "Data di fine",
  "evalus-reports-info": "Qui puoi trovare 'Modelli generali'. Rapporti specifici possono essere trovati o creati e gestiti nel menu 'Liste di controllo'.",
  'role': 'Ruolo',
  'eup': 'PAV',
  "efk-tooltip": "Persona Esperta",
  "eup-tooltip": "Persona Avvertita",
  "efk-pending": "Ordine in sospeso",
  "strictly-required": "Strettamente richiesto",
  "strictly-required-info": "Se abilitato, il rapporto non può essere inviato a meno che questa validazione non abbia successo",
  "validation-failed": "Convalida obbligatoria non riuscita",
  "cannot-submit-invalid-required": "Non è possibile inviare: validazione richiesta fallita",
  "create-new-entry": "Crea nuova voce",
  "trainer-invalid-certificate": "Il trainer non ha più un certificato HV-4 o HV-L valido.",
  "to": "a",
  "date-filter": "Filtro data",
  "clear-filter": "Cancella filtro",
  "oldest-first": "Più vecchio prima",
  "newest-first": "Più nuovo prima",
  "course-documents": "Documenti del corso",
  "upload-documents": "Carica documenti",
  "select-documents": "Seleziona documenti",
  "uploading": "Caricamento",
  "drag-and-drop-files": "Trascina e rilascia i file qui",
  "drop-files-here": "Rilascia i file qui",
  "or-click-to-browse": "o clicca per sfogliare",
  "supported-formats": "Formati supportati",
  "existing-documents": "Documenti esistenti",
  "documents-uploaded-successfully": "Documenti caricati con successo",
  "document-deleted-successfully": "Documento eliminato con successo",
  "no-course-documents-available": "Attualmente non sei assegnato a nessun corso o non sono stati forniti documenti.",
  "more-files": "Altri file",
  "publicProfile": {
    "status": {
      "valid": "Valido",
      "expiringSoon": "In scadenza",
      "expired": "Scaduto",
      "certified": "Certificato",
      "open": "Aperto",
      "none": "Nessuno"
    },
    "jobTitle": {
      "efk": "HV-PES",
      "hv0": "HV sensibilizzata all'alta tensione",
      "hv1-3": "HV-PAV",
    },
    "experienceStartDate": "Esperienza dal",
    "backgroundImage": "Immagine di sfondo",
    "totalCertificatesTitle": "Certificati",
    "totalCertificatesDescription": "Tutte le certificazioni completate",
    "trainingLevelTitle": "Livello di formazione",
    "trainingLevelDescription": "Livello di formazione più alto.",
    "practicalOperationsTitle": "Operazioni pratiche",
    "practicalOperationsDescription": "Esperienza pratica con sistemi HV",
    "vehicleModelsTitle": "Modelli di veicoli",
    "vehicleModelsDescription": "Modelli di veicoli HV gestiti.",
    "dashboardTitle": "Dashboard Esperienza HV",
    "dashboardSubtitle": "Statistiche complete & Competenza HV",
    "certificationsTitle": "Certificazioni",
    "certificationsSubtitle": "Panoramica sulla formazione e le certificazioni HV",
    "instructor": "Istruttore",
    "issuedOn": "Rilasciato",
    "validUntil": "Valido fino al",
    "view": "Visualizza",
    "loadMoreCertificates": "Carica altri certificati",
    "hideCertificates": "Nascondi certificati",
    "nav": {
      "certifications": "Certificazioni",
      "specialTraining": "Formazione Speciale",
      "practicalExperiences": "Esperienze Pratiche",
      "vehicleCategories": "Categorie Veicoli"
    },
    "specialTraining": {
      "title1": "Formazione",
      "title2": "Speciale",
      "subtitle": "Qualifiche aggiuntive e certificazioni speciali"
    },
    "practicalExperiences": {
      "title1": "Esperienze",
      "title2": "Pratiche",
      "subtitle": "Esperienza pratica con sistemi HV",
      "freischaltungen": {
        "title": "Disconnessioni",
        "description": "Eseguito disinserimenti in sistemi ad alta tensione"
      },
      "isolationstests": {
        "title": "Misurazioni di isolamento",
        "description": "Eseguito misurazioni della resistenza di isolamento"
      },
      "potentialtests": {
        "title": "Equalizzazione del potenziale",
        "description": "Eseguito misurazioni di equalizzazione del potenziale"
      },
      "checklists": {
        "title": "Checklist Completate",
        "description": "Checklist di sicurezza completate"
      },
      "chargingCableChecks": {
        "title": "Ispezioni Cavi di Ricarica",
        "description": "Ispezioni sicurezza cavi certificate HV-C"
      },
      "issuedCertificates": {
        "title": "Certificati Rilasciati",
        "description": "Certificazioni rilasciate come istruttore"
      }
    },
    "vehicleCategories": {
      "title1": "Categorie",
      "title2": "Veicoli",
      "subtitle": "Specializzato nelle seguenti categorie di veicoli e applicazioni"
    },
    "gtpCategories": {
      "roadVehicles": "Veicoli stradali",
      "machines": "Macchine",
      "racingVehicles": "Veicoli da corsa",
      "aircraft": "Aeromobili",
      "watercraft": "Imbarcazioni",
      "railVehicles": "Veicoli ferroviari",
      "developmentProduction": "R&S",
      "aftersales": "Post-vendita"
    },
    "footer": {
      "qrTitle": "Accesso QR Code",
      "qrSubtitle": "Scansiona il codice per accesso rapido al profilo",
      "qrHint": "Scansiona con la fotocamera",
      "copyright": "© {year} Evalcard.com - Tutti i diritti riservati",
      "imprint": "Informazioni legali",
      "privacy": "Privacy",
    },
    "shareProfile": "Condividi profilo",
    "currentEmployer": "Datore di lavoro attuale",
    "linkCopied": "Link copiato negli appunti",
    "evalusProfile": "Evalus Profilo",
    "sharingNotSuccessful": "Condivisione non riuscita.",
    "showInvalidCertificates": "mostra certificati scaduti",
    "hideInvalidCertificates": "nascondi certificati scaduti",
    "invalidCertificatesHint": "Certificati nascosti che sono stati sostituiti da quelli più recenti",
    "evalId": "ID Evalus",
    "ogCertifications": "Certificazioni",
    "ogDescription": "Profilo pubblico su EvalCard"
  },
  academy: {
    academy: 'Accademia',
    administration: 'Amministrazione',
    'my-orders': 'I Miei Ordini',
    'manage-courses': 'Gestisci corsi',
    data: 'Dati anagrafici',
    price: 'Prezzo',
    'book-for-me': 'Prenota per me',
    'book-for-employee': 'Prenotare per i dipendenti',
    passing_score: 'Punteggio Minimo in %',
    max_exam_attempts: 'Tentativi massimi di esame',
    max_exam_attempts_hint: '0 = Illimitato',
    exam_attempts_remaining: 'Tentativi rimanenti: {remaining} di {max}',
    exam_attempts_used: 'Tentativi: {used}',
    exam_attempts_limit_reached: 'Numero massimo di tentativi di esame raggiunto',
    'edit-course': '@:edit-course',
    'all-languages-have-content': 'Il contenuto del corso esiste già per tutte le lingue.',
    'must-be-company-member-to-book': 'Devi essere membro di un\'azienda per prenotare i corsi.',
  },
  course: {
    course: 'Corso',
    courses: 'Corsi',
    'my-courses': 'I miei corsi',
    'my-courses-view': 'Panoramica Corsi',
    content: 'Contenuto del corso',
    'edit-content': 'Modifica il contenuto del corso',
    learn: 'Apprendimento',
    'learn-trail': 'Percorso di apprendimento',
    exam: 'Esame',
    'exam-trail': "Percorso d'esame",
    section: 'Sezione',
    addLearnSection: 'Aggiungi Sezione di Apprendimento',
    addLearnTask: 'Aggiungi Compito di Apprendimento',
    addExamSection: "Aggiungi Sezione d'Esame",
    addExamTask: "Aggiungi Domanda d'Esame",
    sectionTitle: 'Titolo della Sezione',
    taskTitle: 'Titolo del Compito',
    questionTitle: 'Titolo della Domanda',
    enterSectionTitle: 'Inserisci il titolo della sezione...',
    enterTaskTitle: 'Inserisci il titolo del compito...',
    enterQuestionTitle: 'Inserisci il titolo della domanda...',
    titleRequired: 'Il titolo è obbligatorio',
    titleTooShort: 'Il titolo deve essere di almeno 2 caratteri',
    itemAddedSuccessfully: 'Elemento aggiunto con successo',
    errorAddingItem: "Errore nell'aggiunta dell'elemento",
    selectItemFromSidebar: 'Seleziona un elemento dalla barra laterale',
    task: 'Compito',
    question: 'Domanda',
    enterTitle: 'Inserisci il titolo...',
    addItem: 'Aggiungi Elemento',
    'purchase-course': 'Acquista Corso',
    'purchase-initiated': 'Acquisto avviato con successo',
    'learning-objectives': 'Obiettivi di Apprendimento',
    prerequisites: 'Prerequisiti',
    syllabus: 'Programma del Corso',
    'learn-section': 'Sezione didattica',
    'exam-section': "Sezione d'esame",
    free: 'Gratuito',
    booking: 'Prenotazione',
    'purchase-date': 'Prenotato il',
    question_type: {
      question_type: 'Tipo di domanda',
      multiple_choice: 'Scelta multipla',
      number: 'Numero',
      yes_no: 'Sì / No',
    },
    operator: {
      operator: 'Operatore',
      equals: 'Uguale',
      notEquals: 'Non uguale',
      greaterThan: 'Maggiore di',
      lessThan: 'Minore di',
      greaterThanOrEqual: 'Maggiore o uguale',
      lessThanOrEqual: 'Minore o uguale',
    },
    correct_answer: 'Risposta corretta',
    yes: 'Sì',
    no: 'No',
    answer: 'Risposta',
    unit: 'Unità',
    select_course: 'Seleziona Corso',
    select_language: 'Seleziona Lingua del Corso',
    select_users: 'Seleziona Utenti',
    error: {
      publish: 'Impossibile pubblicare il corso',
      course_content_required: 'È richiesto almeno un contenuto del corso',
      certification_authority_required: "È richiesta almeno un'autorità di certificazione",
      certificate_template_missing: 'È necessario selezionare un modello di certificato per tutte le autorità di certificazione in ogni contenuto del corso',
      learn_section_task_required: 'Ogni sezione di apprendimento deve avere almeno un compito',
      exam_section_task_required: "Ogni sezione d'esame deve avere almeno una domanda",
      monetization_required: 'Il corso deve essere contrassegnato come gratuito o avere un prodotto Paddle selezionato',
    },
    finish_course: 'Completa il corso',
    completed_message: 'Hai completato con successo questo corso.',
    linked_exam_section: "Sezione d'esame collegata",
    linked_exam_section_hint: "Dopo aver completato questa sezione di apprendimento, verrà presentata questa sezione d'esame",
    inline_exam_section: "Domande d'esame",
    inline_exam_section_info: 'Rispondi a tutte le domande per continuare. Le tue risposte sono definitive.',
    question_progress: 'Domanda {current} di {total}',
    complete_exam_section: 'Completa sezione',
    answered_during_learning: "Risposto durante l'apprendimento",
    section_already_answered: 'Questa sezione è già stata risposta',
    answers_are_final: 'Le risposte non possono essere modificate',
  },
  enrollment: {
    status: {
      in_progress: 'Iniziato',
      not_started: 'Non Iniziato',
      completed: 'Completato',
    },
    enrolled_courses: 'Corsi Iscritti',
    enroll_course: 'Iscriviti al Corso',
    enrolled_on: 'Iscritto il',
  },
  order: {
    order: 'Ordinare | Ordini',
    my_orders: 'I Miei Ordini',
    view_order: 'Visualizza',
    ordered_at: 'Ordinato il',
    status: {
      paid: 'Pagato',
      pending: 'In Attesa',
      failed: 'Fallito',
      refunded: 'Rimborsato',
      cancelled: 'Annullato',
    },
    payment: {
      paddle: 'Paddle',
      request: 'Richiesta',
      none: 'Nessuno',
    },
    payment_method: 'Metodo di Pagamento',
    purchased_by: 'Acquistato da',
    purchased_for: 'Acquistato per',
    product: 'Prodotto',
    'page-title': 'Ordine',
    thank_you: 'Grazie per il tuo acquisto!',
    no_transaction_headline: 'Ordine non trovato',
    no_transaction_text: 'Questo ordine non esiste o si è verificato un errore.',
    back_to_courses: 'Torna ai corsi',
    go_to_my_courses: 'Vai ai miei corsi',
    purchase_now: 'Acquista ora',
    payment_pending: 'Pagamento in sospeso',
    payment_pending_text:
      'Il tuo ordine è stato ricevuto ma il pagamento non è ancora stato completato. Si prega di completare il pagamento per accedere al tuo corso.',
    cancel_success: 'Ordine annullato con successo',
    cancel_error: "Impossibile annullare l'ordine",
  },
  language: 'Lingua',
  short_description: 'Descrizione Breve',
  progress: 'Progresso',
  total: 'Totale',
  complete_section: 'Completa Sezione',
  mark_task_complete: 'Segna Compito come Completato',
  video_not_supported: 'Il tuo browser non supporta l\'elemento video.',
  overall_progress: 'Progresso Complessivo',
  section_progress: 'Progresso della Sezione',
  task_completed: 'Compito completato con successo',
  section_completed: 'Sezione completata con successo',
  error_completing_task: 'Errore nel completare il compito',
  error_completing_section: 'Errore nel completare la sezione',
  next: 'Avanti',
  finish_learning: 'Termina Apprendimento',
  start_learning: 'Inizia Apprendimento',
  continue_learning: 'Continua Apprendimento',
  take_exam_attempt: 'Inizia Tentativo Esame',
  copy_course: 'Copia Corso',
  select: 'Seleziona',
  exam_results: {
    congratulations: 'Congratulazioni!',
    not_passed: 'Non Superato',
    score: 'Punteggio',
    you_passed: "Hai superato con successo l'esame!",
    need_score_to_pass: 'Hai bisogno di {score} per superare. Riprova.',
    score_details: 'Dettagli Punteggio',
    question: 'Domanda',
    back_to_course: 'Torna al Corso',
    retake_exam: 'Ripeti Esame',
    view_certificate: 'Visualizza Certificato',
    download_certificate: 'Scarica Certificato',
  },
  exam_export: {
    export_pdf: 'Esporta come PDF',
    title: 'Risultato dell’esame',
    participant: 'Partecipante',
    birthday: 'Data di nascita',
    course: 'Corso',
    attempt_number: 'Tentativo',
    started_at: 'Iniziato il',
    finished_at: 'Completato il',
    overall_score: 'Punteggio complessivo',
    passed: 'Superato',
    failed: 'Non superato',
    given_answer: 'Risposta data',
    correct_answer: 'Risposta corretta',
    no_answer: 'Nessuna risposta',
    yes: 'Sì',
    no: 'No',
    select_attempt: 'Seleziona tentativo',
    no_attempts: 'Nessun tentativo completato disponibile',
    no_exam: 'Questo corso non prevede un esame',
    generating: 'Generazione del PDF …',
    export_failed: 'Esportazione non riuscita',
  },
  'academy-assignment': {
    title: 'Corsi accademia assegnati',
    'academy-course': 'Corso accademia',
    'available-for-regular-courses': 'Selezionabile per i corsi regolari',
    'for-regular-courses-badge': 'Per corsi regolari',
    'cannot-publish-regular-course': 'Questo corso non può essere pubblicato perché è destinato ai corsi regolari',
    language: 'Lingua',
    'select-course-first': 'Seleziona prima un corso accademia',
    'no-matching-courses': 'Nessun corso accademia corrispondente disponibile (non pubblicato, abilitato, livello corrispondente)',
    type: 'Tipo',
    'type-entry': 'Test d’ingresso',
    'type-intermediate': 'Test intermedio',
    'type-final': 'Esame finale',
    assign: 'Assegna corso accademia',
    remove: 'Rimuovi assegnazione',
    'remove-warning': 'Rimuovendo l’assegnazione verranno eliminate le iscrizioni e i risultati degli esami dei partecipanti per questo corso accademia. Continuare?',
    'assigned-successfully': 'Corso accademia assegnato con successo',
    'removed-successfully': 'Assegnazione rimossa con successo',
    results: 'Risultati dei partecipanti',
    participant: 'Partecipante',
    score: 'Punteggio',
    status: 'Stato',
    attempts: 'Tentativo',
    passed: 'Superato',
    failed: 'Non superato',
    'in-progress': 'In corso',
    'not-started': 'Non iniziato',
  },
  exam_interface: {
    sections: 'Sezioni',
    overall_progress: 'Progresso Complessivo',
    questions: 'domande',
    progress: 'Progresso',
    section: 'Sezione',
    question_of: 'Domanda {current} di {total}',
    answered: 'Risposta data',
    not_answered: 'Nessuna risposta',
    previous: 'Precedente',
    next: 'Avanti',
    submit_exam: 'Invia Esame',
    quick_navigation: 'Navigazione Rapida',
    submit_exam_confirm: "Inviare l'esame?",
    submit_exam_message: 'Sei sicuro di voler inviare il tuo esame?',
    answered_count: 'Hai risposto a <strong>{answered}</strong> su <strong>{total}</strong> domande.',
    cannot_change_warning: 'Una volta inviato, non potrai modificare le tue risposte.',
    loading: 'Caricamento',
    error: 'Errore',
    back: 'Indietro',
    select_certificate_authority: 'Seleziona Autorità di Certificazione',
    select_authority_message: "Seleziona un'autorità di certificazione per emettere il tuo certificato.",
    no_authorities_available: 'Nessuna autorità di certificazione disponibile per questo corso.',
    certificate_issued: 'Certificato emesso con successo!',
    error_issuing_certificate: "Errore nell'emissione del certificato",
    exam_submitted_successfully: 'Esame inviato con successo!',
    exam_submit_error: "Errore nell'invio dell'esame",
  },
  could_not_add_section: 'Impossibile aggiungere la sezione',
  successfully_added_section: 'Sezione aggiunta con successo',
  could_not_add_task: 'Impossibile aggiungere il compito',
  successfully_added_task: 'Compito aggiunto con successo',
  could_not_remove_attachment: "Impossibile rimuovere l'allegato",
  successfully_removed_attachment: 'Allegato rimosso con successo',
  could_not_remove_task: 'Impossibile rimuovere il compito',
  successfully_removed_task: 'Compito rimosso con successo',
  could_not_remove_section: 'Impossibile rimuovere la sezione',
  successfully_removed_section: 'Sezione rimossa con successo',
  "default-academy-issuer": "Ente certificatore predefinito per i certificati dell'Academy",
  "default-academy-issuer-hint": "Rilascia automaticamente i certificati dei corsi Academy completati, a meno che il partecipante non abbia già un certificato di un altro ente assegnato al corso. Può esserci un solo ente predefinito.",
  'remove-efk-description': 'Vuoi davvero rimuovere lo stato PES dall\'utente?',
  'cancel-efk-description': 'Vuoi davvero annullare l\'invito PES per questo utente?',
}
